// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1jqtm","infoBtn":"quickbooks_infoBtn__3Ng4p","formBox":"quickbooks_formBox__5RaGn","formFooter":"quickbooks_formFooter__ONxLj"};